module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/z-logo-animated-22354d6b51026ee2f4160d39f2c72603.gif";